import { ServerDate } from '../../../platform/ServerDate';
import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Stopwatch } from './Stopwatch';

const timeSelector = PropertyStripLayout<Stopwatch>((d, s, o, w, a) => {

    const menu = w.createMenu({
        text: 'Set Time...',
        image: 'deqo://icons/hero/clock',
    });

    const tm = (label: string, value: [number, number]) => ({ label, value });
    const opts = [
        tm('Set 10s', [0, 10]),
        tm('Set 30s', [0, 30]),
        tm('Set 1m', [1, 0]),
        tm('Set 2m', [2, 0]),
        tm('Set 5m', [5, 0]),
        tm('Set 10m', [10, 0]),
    ];

    const items = opts.map(x =>
        w.createButton({
            text: x.label,
            onAction() {
                o.update(u => {
                    u.rolling(a.keyFor('minutes', 'seconds'));
                    a.set('minutes', `${x.value[0]}`);
                    a.set('seconds', `${x.value[1]}`);
                    if (!!a.get('timeStarted', { useFirstIfVarying: true })) {
                        a.set('timeStarted', ServerDate.now());
                    }
                });
                menu.update({ open: false });
            }
        })
    );

    menu.update({ items });
    return [menu];

});

export const stopwatchPropertyLayout = LockablePropertyStripLayout<Stopwatch>((d, s, o, w, a) => [
    //
    // Color
    ...timeSelector(d, s, o, w, a),
    //
    // Color
    w.createColorSelector({
        allowNull: true,
        autoSelect: true,
        groups: true,
        value: a.get('color'),
        text: 'Color',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('color'));
                a.set('color', this.value!);
            });
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);
